module.exports = __webpack_public_path__ + "img/2019-in-xrp.fc22bd81.png";